<!--suppress HtmlFormInputWithoutLabel -->
<input class="timepicker-dial__control timepicker-dial__item"
       [ngClass]="{'timepicker-dial__item_active': isActive, 'timepicker-dial__control_editable': isEditable}"
       [(ngModel)]="time" (input)="updateTime()" (focus)="saveTimeAndChangeTimeUnit($event, timeUnit)"
       (blur)="formatTime()" [readonly]="!isEditable" [timepickerAutofocus]="isActive" (keydown)="onKeyDown($event)">
